module.exports = __webpack_public_path__ + "static/img/ck-icon.df2147c2.png";